// src/components/SectionHeading.tsx
import { motion } from 'framer-motion';

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  alignment?: 'left' | 'center' | 'right';
}

const SectionHeading = ({ 
  title, 
  subtitle, 
  alignment = 'center' 
}: SectionHeadingProps) => {
  const getAlignmentClasses = () => {
    switch (alignment) {
      case 'left':
        return 'text-left';
      case 'right':
        return 'text-right';
      default:
        return 'text-center';
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-100px" }}
      transition={{ duration: 0.5 }}
      className={`mb-12 ${getAlignmentClasses()}`}
    >
      <h2 className="text-3xl md:text-4xl font-bold text-stone-800 mb-3">{title}</h2>
      {subtitle && (
        <p className="text-lg text-stone-600 max-w-3xl mx-auto">{subtitle}</p>
      )}
      <div className={`mt-4 h-1 w-24 bg-gradient-to-r from-primary via-secondary to-accent ${alignment === 'center' ? 'mx-auto' : alignment === 'right' ? 'ml-auto' : ''}`}></div>
    </motion.div>
  );
};

export default SectionHeading;